import React from 'react'
import { useIntl } from 'react-intl'

import { Container } from '../styles/PageLayout'
import { BodyM, TitleM } from '../styles/Typography'
import { GeofencingStyled } from '../styles/components/GeofencingStyled'

/**
 * The geofencing block.
 * @returns {FunctionComponent}
 */
const Geofencing = () => {
  const intl = useIntl()

  return (
    <GeofencingStyled $alignCenter>
      <Container $column $mobileColumn $alignItems="center">
        <TitleM className="title">{intl.formatMessage({ id: 'block_geofencing_title' })}</TitleM>
        <BodyM className="text">{intl.formatMessage({ id: 'block_geofencing_text' })}</BodyM>
        <div className="video">
          <video width="100%" autoPlay={true} loop={true} muted={true} playsInline>
            <source src="https://www.1home.io/xassets/geofencing-video.mp4" type="video/mp4" />
          </video>
        </div>
      </Container>
    </GeofencingStyled>
  )
}

export default Geofencing
